const SHOW_ALERT_SUCCESS = 'SHOW_ALERT_SUCCESS'
const SHOW_ALERT_ERROR = 'SHOW_ALERT_ERROR'
const CLOSE_ALERT = 'CLOSE_ALERT'
const ERROR = 'ERROR'
const SUCCESS = 'SUCCESS'
const WARNING = 'WARNING'

export {
  SHOW_ALERT_ERROR,
  SHOW_ALERT_SUCCESS,
  CLOSE_ALERT,
  SUCCESS,
  ERROR,
  WARNING
}
